import { render, staticRenderFns } from "./BorderBox6.vue?vue&type=template&id=719f207e"
import script from "./BorderBox6.vue?vue&type=script&lang=js"
export * from "./BorderBox6.vue?vue&type=script&lang=js"
import style0 from "./BorderBox6.vue?vue&type=style&index=0&id=719f207e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports